import { randomUuid } from "@models/utils/uuid";
/**
 * Per-tab app-instance identity — the web stand-in for Unity's
 * `IAppConfig.AppInstanceID`. Stamped as `aid` on every outbound session
 * event and used to drop our own echoes on receive (Unity
 * `AWSServerEventListenerModel.IgnoreEvent` compares the same field).
 *
 * `sessionStorage` scope is deliberate: each browser tab gets its own id
 * (two tabs of the same account behave like two Unity app instances), and
 * the id survives in-tab reloads so reconnects keep the same identity.
 */

const K_STORAGE_KEY = "campfire.web.appInstanceId";

export function getAppInstanceId(): string {
  const existing = window.sessionStorage.getItem(K_STORAGE_KEY);
  if (existing) return existing;
  const id = randomUuid();
  window.sessionStorage.setItem(K_STORAGE_KEY, id);
  return id;
}

/** True when the event payload's `aid` is this tab's own app instance. */
export function isOwnAppInstance(aid: unknown): boolean {
  return typeof aid === "string" && aid.length > 0 && aid === getAppInstanceId();
}
